import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap';
import 'jquery';
import '../src/styles/SLCGP.css'